const SUBSCRIPTIONS_CHANNEL_KEY = 'online-subscription';

export { SUBSCRIPTIONS_CHANNEL_KEY };
//# sourceMappingURL=constants.js.map
